"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectState = void 0;
class EffectState {
    constructor(id, duration, creatorId, targetId, args, supernatural) {
        this.id = id;
        this.duration = duration;
        this.creatorId = creatorId;
        this.targetId = targetId;
        this.args = args;
        this.supernatural = supernatural;
        this.meta = {};
        this.removed = false;
        this.appliedOnTurn = 0;
    }
}
exports.EffectState = EffectState;
